/* Static chrome strings (nav, forms, footer, viz labels) per locale.
   Block content (headlines, bullets, screenshots) lives in the database
   and is injected as window.__FRAMERIVER_CONTENT__ — see LandingPayload. */
const COPY = {
  en: {
    signIn: "Sign in",
    download: "Download",
    downloadFor: { mac: "Download for Mac", win: "Download for Windows", any: "Get the desktop app" },
    theme: { label: "Theme", system: "System", light: "Light", dark: "Dark" },
    instructions: "Guides",
    reel: { soundOn: "Watch with sound", soundOnShort: "Sound on", soundOff: "Mute", fullscreen: "Full screen", play: "Play" },
    infraMore: "+ dozens more",
    compareLabels: ["before", "after"],
    memoryViz: {
      nodes: {
        characters: "Characters",
        locations: "Locations",
        scripts: "Scripts",
        style: "Style & concepts",
        references: "References",
        shots: "Shots",
      },
      coreTitle: "Content Memory",
      coreBody: "One growing source of truth for the whole universe.",
      tags: ["consistent", "efficient", "scalable"],
    },
    footer: {
      tagline: "The AI video production platform for studios, teams, and solo creators.",
      columns: [
        ["Platform", [
          ["Script & structure", "#script"],
          ["Characters & locations", "#assets"],
          ["Shot workspace", "#video"],
          ["AI director agent", "#agent"],
          ["Billing & registries", "#billing"],
          ["Pricing & payment", "/pricing"],
        ]],
        ["More", [
          ["Sketch editing", "#sketch"],
          ["Animatics", "#animatics"],
          ["Audio", "#audio"],
          ["Canvas", "#canvas"],
          ["Content Memory", "#memory"],
          ["MCP for Claude & ChatGPT", "#mcp"],
        ]],
        ["Company", [
          ["About", "/about"],
          ["Vision", "/vision"],
        ]],
      ],
      contact: "Contact",
      privacy: "Privacy",
      personalData: "Personal data",
      cookies: "Cookies",
      terms: "Terms of Service",
      closing: "Build whole worlds, not single clips.",
    },
  },
  ru: {
    signIn: "Войти",
    download: "Скачать",
    downloadFor: { mac: "Скачать для Mac", win: "Скачать для Windows", any: "Десктоп-приложение" },
    theme: { label: "Тема", system: "Как в системе", light: "Светлая", dark: "Тёмная" },
    instructions: "Инструкции",
    reel: { soundOn: "Смотреть со звуком", soundOnShort: "Со звуком", soundOff: "Выключить звук", fullscreen: "На весь экран", play: "Смотреть" },
    infraMore: "+ ещё десятки",
    compareLabels: ["до", "после"],
    memoryViz: {
      nodes: {
        characters: "Персонажи",
        locations: "Локации",
        scripts: "Сценарии",
        style: "Стиль и концепты",
        references: "Референсы",
        shots: "Шоты",
      },
      coreTitle: "Память контента",
      coreBody: "Единый растущий источник правды всей вселенной.",
      tags: ["консистентно", "эффективно", "масштабно"],
    },
    footer: {
      tagline: "AI-платформа видеопроизводства для студий, команд и соло-креаторов.",
      columns: [
        ["Платформа", [
          ["Сценарий и структура", "#script"],
          ["Персонажи и локации", "#assets"],
          ["Работа с видео", "#video"],
          ["AI агент-режиссер", "#agent"],
          ["Биллинг и реестры", "#billing"],
          ["Тарифы и оплата", "/pricing"],
        ]],
        ["Ещё", [
          ["Скетч-правки", "#sketch"],
          ["Аниматики", "#animatics"],
          ["Аудио", "#audio"],
          ["Холст", "#canvas"],
          ["Память контента", "#memory"],
          ["MCP для Claude и ChatGPT", "#mcp"],
        ]],
        ["Компания", [
          ["О нас", "/about"],
          ["Видение", "/vision"],
        ]],
      ],
      contact: "Контакты",
      privacy: "Конфиденциальность",
      personalData: "Персональные данные",
      cookies: "Cookie",
      terms: "Оферта",
      closing: "Стройте целые миры, а не отдельные клипы.",
    },
  },
};

export default COPY;
